import * as angular from 'angular';
import {IController} from "angular";

export class CreateDeliveryButtonCtrl implements IController {
  loading: any;
  direction: any;
  onCreate: any;

  /* @ngInject */
  constructor() {
  }

  $onInit() {

  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('createDeliveryButton', {
    bindings: {
      loading: '<?',
      direction: '<',
      onCreate: '&'
    },
    template: require('./create-delivery-button.html').default,
    controller: CreateDeliveryButtonCtrl
  });
